import { Input, InputProps } from '@cast/design-system';

type Props = {
  value?: string | null;
} & InputProps;

export const NativeSettingsInput = ({ value, ...rest }: Props) => {
  const hasValue = !!value;
  return (
    <Input
      value={hasValue ? value : '-'}
      disabled={!hasValue}
      readOnly={hasValue}
      size="small"
      {...rest}
    />
  );
};
